import ButtonIcon from 'components/ButtonIcon';
import Trash from 'components/icons/trash';
import Pencil from 'components/icons/pencil2';
import UserIcon from 'components/icons/user';
import Globe from 'components/icons/globe';
import {
    UserItemContainer, UserItemInfo, UserItemTitle, UserItemSubtitle, UserItemActions,
} from './styled';

interface SipUser {
    id: string;
    username: string;
    sipAddress: string;
    friendlyName?: string;
}

interface Props {
    user: SipUser;
    onEdit: () => void;
    onDelete: () => void;
}

const UserItem = ({ user, onEdit, onDelete }: Props) => (
    <UserItemContainer>
        <UserItemInfo>
            <UserItemTitle>
                <UserIcon />
                {user.friendlyName || user.username}
            </UserItemTitle>
            <UserItemSubtitle>
                <Globe />
                {user.sipAddress}
            </UserItemSubtitle>
        </UserItemInfo>
        <UserItemActions>
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Pencil />}
                tooltip="Edit SIP user"
                size="small"
                onClick={onEdit}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Trash />}
                tooltip="Remove SIP user"
                size="small"
                onClick={onDelete}
            />
        </UserItemActions>
    </UserItemContainer>
);

export default UserItem;
